(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schnuffinest-roller-popup"]) return;
  try {
    
  if (!customElements.get('schnuffinest-roller-popup')) {
    customElements.define('schnuffinest-roller-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.key = 'sn-roller-20-2026-shown';
        this.expires = Date.parse(this.dialog.dataset.expires);
        this.attempts = 0;
        this.querySelectorAll('[data-sn-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('sn-roller-popup-open');
          clearTimeout(this.expiryTimer);
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.dialog.close();
          }
        });
        this.onSelect = (event) => {
          if (window.Shopify?.designMode && event.target.contains(this)) this.openPopup(true);
        };
        document.addEventListener('shopify:section:select', this.onSelect);
        this.timer = setTimeout(() => this.openPopup(), Number(this.dialog.dataset.delay) || 6000);
      }

      seen() {
        if (window.Shopify?.designMode) return false;
        try { return sessionStorage.getItem(this.key) === '1'; } catch { return false; }
      }

      openPopup(force = false) {
        if (!this.isConnected || this.dialog.open || !Number.isFinite(this.expires) || Date.now() >= this.expires || (!force && this.seen())) return;
        const busy = document.hidden ||
          document.activeElement?.matches('input, select, textarea, [contenteditable="true"]') ||
          [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, menu-drawer details[open], details-modal details[open]')]
            .some((element) => {
              if (element === this.dialog || element.closest('[hidden], [aria-hidden="true"], details:not([open])')) return false;
              const rect = element.getBoundingClientRect();
              const style = getComputedStyle(element);
              return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight &&
                style.visibility === 'visible' && style.display !== 'none' && Number(style.opacity) > 0;
            });
        if (busy && !force) {
          if (this.attempts++ < 60) this.timer = setTimeout(() => this.openPopup(), 2000);
          return;
        }
        this.dialog.showModal();
        document.documentElement.classList.add('sn-roller-popup-open');
        if (!window.Shopify?.designMode) {
          try { sessionStorage.setItem(this.key, '1'); } catch {}
        }
        this.scheduleExpiry();
      }

      scheduleExpiry() {
        const remaining = this.expires - Date.now();
        if (remaining <= 0) { this.dialog.close(); return; }
        this.expiryTimer = setTimeout(() => this.scheduleExpiry(), Math.min(remaining, 2147483647));
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.expiryTimer);
        document.removeEventListener('shopify:section:select', this.onSelect);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
